<template>
  <div>
    <v-card color="ma-0 pa-0" :loading="loading">
      <document-action-header
        :title="$t('DocumentAttachments')"
        @on-close-click="onCloseClick"
      >
        <template slot="actionTemplate">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
                @click="add"
                v-if="permissions.documentAttachmentCreate"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Add") }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
                @click="downloadAll"
                v-if="permissions.documentAttachmentDownload"
                v-show="attachmentsList.length > 0"
              >
                <v-icon>mdi-briefcase-download</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("DownloadAll") }}</span>
          </v-tooltip>
        </template>
      </document-action-header>

      <v-card-text class="overflow-y-auto" style="max-height: 250px">
        <v-row
          justify="center"
          align="center"
          v-if="
            attachmentsList.length == 0 &&
            !loading &&
            permissions.documentAttachmentCreate
          "
        >
          <div class="text-center">
            <a link @click="add">
              {{ $t("Add") }}
              <v-icon>mdi-plus</v-icon>
            </a>
          </div>
        </v-row>

        <template v-for="attachment in attachmentsList">
          <AttachmentItem
            :attachment="attachment"
            :canEdit="permissions.documentAttachmentUpdate"
            :canDelete="permissions.documentAttachmentDelete"
            :canDownload="permissions.documentAttachmentDownload"
            v-bind:key="attachment.id"
            @on-edit-attachment="onEdit"
            @on-remove-attachment="onRemove"
            @on-display-attachment="onDisplay"
          />
        </template>
      </v-card-text>
    </v-card>
    <AttachmentModal :ref="modalKey" @on-attachment-saved="onSaved" />
    <AttachmentDisplayModal :ref="displayModalKey" />
  </div>
</template>

<script>
import DocumentActionHeader from "@/components/search/results/list/item/actions/DocumentActionHeader";
import AttachmentItem from "@/components/search/results/list/item/actions/attachment/AttachmentItem";
import AttachmentModal from "@/components/search/results/list/item/actions/attachment/AttachmentModal";
import AttachmentDisplayModal from "@/components/search/results/list/item/actions/attachment/AttachmentDisplayModal";
import AttachmentService from "@/services/AttachmentService";
import Attachment from "@/ecm/models/search/results/list/Attachment";

export default {
  name: "attachmentList",
  components: {
    DocumentActionHeader,
    AttachmentItem,
    AttachmentModal,
    AttachmentDisplayModal,
  },
  props: {
    documentId: {
      type: Number,
      required: true,
    },
    permissions: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      attachmentsList: [],
      loading: false,
      modalKey: "modalAttachment",
      displayModalKey: "modalAttachmentDisplay",
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modalKey];
    },
    displayModalInstance() {
      return this.$refs[this.displayModalKey];
    },
  },
  methods: {
    onCloseClick() {
      this.$emit("on-close-click");
    },
    onSaved() {
      this.loadData();
    },
    onRemove(attachmentId) {
      this.$confirm(this.$t("ItemDeleteConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-warning",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          AttachmentService.remove(attachmentId).then((result) => {
            if (result) {
              this.loadData();
            }
          });
        }
      });
    },
    downloadAll() {
      AttachmentService.downloadAll(this.documentId);
    },
    onEdit(attachment) {
      this.modalInstance.edit(attachment);
    },
    onDisplay(attachment) {
      this.displayModalInstance.displayDocumentAttachment(
        this.documentId,
        attachment
      );
    },
    add() {
      this.modalInstance.new(this.documentId);
    },
    loadData() {
      this.loading = true;
      AttachmentService.getList(this.documentId).then((data) => {
        this.attachmentsList = data.map(function (dto) {
          return new Attachment(dto);
        });
        this.loading = false;
        this.$emit("on-attachment-updated", data.length);
      });
    },
  },
};
</script>